import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=50aa4e17&scoped=true"
import script from "./Label.vue?vue&type=script&lang=ts"
export * from "./Label.vue?vue&type=script&lang=ts"
import style0 from "./Label.vue?vue&type=style&index=0&id=50aa4e17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa4e17",
  null
  
)

export default component.exports